import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  genresMoviesId: [],
  genresTvId: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.FETCH_GENRES_MOVIES_ID_FULFILLED: {
      return {
        ...state,
        genresMoviesId: action.payload,
      };
    }

    case actionsTypes.FETCH_GENRES_TV_ID_FULFILLED: {
      return {
        ...state,
        genresTvId: action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
